import React from "react";
import { useTranslation } from "react-i18next";
import InfoBottomSheet from "@shared/infoBottomSheet";
import { useSelector } from "react-redux";
import { PAN_STATUS_VARIANTS } from "constants/panStatusVariants";

interface IMessageType {
  mainMessage: string;
  title: string;
  detailMessage: string;
}
interface IMessage {
  PAN_UNAVAILABLE_CHECKED: IMessageType;
  PAN_INACTIVE: IMessageType;
  PAN_INOPERATIVE: IMessageType;
}

function ConfirmPagePanNote() {
  const { t } = useTranslation();
  const panValidation = useSelector((state: any) => state.pan) as {
    panStatus: keyof IMessage;
    panResponse?: {
      fullName: string;
    };
  };

  const messages: IMessage = {
    PAN_UNAVAILABLE_CHECKED: {
      mainMessage: t("pan_unavailable_main_message", {
        defaultValue:
          "A 20% TDS will be deducted from your payouts if you don’t provide a PAN.",
      }),
      title: t("twenty_percent_tax_question", {
        defaultValue: "Why is 20% TDS being deducted?",
      }),
      detailMessage: t("pan_unavailable_detail_message", {
        defaultValue:
          "If the PAN number not provided, as per India’s 194R tax guidelines, a 20% tax will be deducted",
      }),
    },
    PAN_INACTIVE: {
      mainMessage: t("itr_not_filed_message", {
        defaultValue:
          "A 20% TDS may apply to your payouts as your PAN is not active.",
      }),
      title: t("twenty_percent_tax_question", {
        defaultValue: "Why is 20% TDS being deducted?",
      }),
      detailMessage: t("pan_not_compliant_message", {
        defaultValue:
          "If your PAN is non-compliant or inoperative (e.g., ITR filings not completed for the last 2 years, PAN is not linked to Aadhaar), a 20% TDS will be deducted as per India’s 194R tax guidelines.",
      }),
    },
    PAN_INOPERATIVE: {
      mainMessage: t("pan_inoperative_message", {
        defaultValue:
          "A 20% TDS may apply to your payouts as your PAN is not active.",
      }),
      title: t("twenty_percent_tax_question", {
        defaultValue: "Why is 20% TDS being deducted?",
      }),
      detailMessage: t("pan_inoperative_details_message", {
        defaultValue:
          "If your PAN is non-compliant or inoperative (e.g., ITR filings not completed for the last 2 years, PAN is not linked to Aadhaar), a 20% TDS will be deducted as per India’s 194R tax guidelines.",
      }),
    },
  };

  const message = () => {
    return messages[panValidation?.panStatus];
  };

  return (
    <>
      {(panValidation?.panStatus ===
        PAN_STATUS_VARIANTS.PAN_UNAVAILABLE_CHECKED ||
        panValidation?.panStatus === PAN_STATUS_VARIANTS.PAN_INACTIVE ||
        panValidation?.panStatus === PAN_STATUS_VARIANTS.PAN_INOPERATIVE) && (
        <InfoBottomSheet
          mainMessage={message().mainMessage}
          title={message().title}
          detailMessage={message().detailMessage}
        />
      )}
    </>
  );
}

export default ConfirmPagePanNote;
